module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-10@2x__e237181a6c161289117a5258d68a3af0.png";